import React from 'react';
import { Card, CardBody } from 'reactstrap';
import Heading from 'components/Heading';
import CommonPromoBannerAndAdvt from './components/CommonPromoBannerAndAdvt';

const PromotionalImages = () => {
  return (
    <>
      <div className="mb-3 top-head pb-1 d-flex justify-content-between">
        <Heading title="Banner" />
      </div>

      <Card className="border-0 card-box page-card-box">
        <CardBody>
          <CommonPromoBannerAndAdvt />
        </CardBody>
      </Card>
    </>
  );
};

export default PromotionalImages;
